/** What a piece of a grow is for: the dynamic content draws by it, the name
 * layer labels by it, book3d measures its flaps by it. A `page` is any panel
 * with a face to show — a cover's board, a folder's panel, a box's wall, a
 * signature's page —; a `spine` the strip between two; a `flap` what hangs
 * off an edge, a cover's, a pocket, a tab. */
export const enum GrowContentKind {
  FLAP = "flap",
  PAGE = "page",
  SPINE = "spine",
}
